import AnalyticsService from '../../services/AnalyticsService';

class SocialShare {
    constructor() {
        this.containers = document.querySelectorAll('[data-social-share]');
    }

    init = () => {
        [...this.containers].forEach((container) => {
            container.addEventListener('click', this.handleClick);
        });
    };

    handleClick = async (event) => {
        const actionElement = event.target.closest('[data-social-share-action]');

        if (!actionElement) {
            return;
        }

        const container = event.currentTarget;
        const { url, title } = container.dataset;
        const action = actionElement.dataset.socialShareAction;

        AnalyticsService.track('News', 'Share article', title);

        if (action === 'copy') {
            event.preventDefault();
            await this.copyLink(url, container, actionElement);
            return;
        }

        if (action === 'instagram') {
            event.preventDefault();
            await this.shareInstagram(url, title, container);
        }
    };

    copyLink = async (url, container, button) => {
        try {
            await navigator.clipboard.writeText(url);
            this.showFeedback(container, button.dataset.copiedLabel);
        } catch {
            this.showFeedback(container, button.dataset.copiedLabel);
        }
    };

    shareInstagram = async (url, title, container) => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title,
                    url,
                });
                return;
            } catch {
                // Fall through to clipboard copy.
            }
        }

        try {
            await navigator.clipboard.writeText(url);
            this.showFeedback(container, container.querySelector('[data-social-share-action="copy"]')?.dataset.copiedLabel);
        } catch {
            this.showFeedback(container, container.querySelector('[data-social-share-action="copy"]')?.dataset.copiedLabel);
        }
    };

    showFeedback = (container, message) => {
        if (!message) {
            return;
        }

        const feedback = container.querySelector('.social-share__feedback');

        if (!feedback) {
            return;
        }

        feedback.textContent = message;
        feedback.classList.remove('visually-hidden');

        window.setTimeout(() => {
            feedback.textContent = '';
            feedback.classList.add('visually-hidden');
        }, 3000);
    };
}

export default SocialShare;
